const isSP = () => {
  return $(window).innerWidth() <= 750;
};

const isPC = () => {
  return $(window).innerWidth() > 750;
};

const EnvUtil = {
  isSP: isSP,
  isPC: isPC,
};

export default EnvUtil;
